import axios from '@axios'

const PREFIX = 'dashboards-proposta'

export default {
  getDadosIniciais() {
    return axios.get(`${PREFIX}/dados-iniciais`)
  },
  getTotalPropostas() {
    return axios.get(`${PREFIX}/total-propostas`)
  },
  getTotalChecklist() {
    return axios.get(`${PREFIX}/checklist`)
  },
  getTotalContratos() {
    return axios.get(`${PREFIX}/contratos`)
  },
  getDetalhamentoProposta() {
    return axios.get(`${PREFIX}/detalhamento-proposta`)
  },
  getDetalhamentoFinalizadas(datasParaFiltro) {
    return axios.post(`${PREFIX}/finalizadas?datasParaFiltro=${datasParaFiltro}`)
  },
  gerarPlanilhaPropostasFinalizadas(dadosExportacao) {
    return axios.post(`${PREFIX}/propostas-finalizadas/gera-planilha`, dadosExportacao)
  },
  deleteUpload(nomeArquivo) {
    return axios.delete(`${PREFIX}/delete-upload?arquivo=${nomeArquivo}`)
  },
}
